import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import ReusableTable from '../../components/other/ReuseableTable'
import { useGetIpAddressesQuery, useLazyGetIpAddressesQuery } from '../../redux/apis/domainsManagement/ipAddress/dMIpAddressApiSlice'
import Loader from '../pages/loader'
import EditCreateIpAddress from '../../components/IPISP/EditCreateIpAddress'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import IspDropdown from '../../components/IspDropdown'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const IpAddress = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)
  const { data, isLoading, error, isFetching } = useGetIpAddressesQuery({
    expand: ['isp', 'last_updated_by'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'IP ADDRESS',
      dataIndex: 'ip_address',
      key: 'ip_address',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'ISP',
      dataIndex: 'isp',
      key: 'isp.isp_name',
      filter: true,
      filterComponent: IspDropdown,
      render: (text) => <p>{text?.isp_name}</p>
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text) => (
        <p>
          {text?.first_name} {text?.last_name}
        </p>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (_, record) => (
        <div className='flex gap-2'>
          {can('change_ipaddress') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = (paginationInfo) => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_ipaddress') && create && (
        <EditCreateIpAddress
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {can('change_ipaddress') && edit && (
        <EditCreateIpAddress
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetIpAddressesQuery}
            fileName='ipaddress'
          />
          {can('add_ipaddress') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New IP Address
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true,
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default IpAddress
